import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { CoreConfigService } from "../../../../@core/services/config.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CitiesService } from "../../../auth/service/cities.service";
import { UtilsService } from "../../../auth/service/utils.service";
import moment from "moment";
import { ActivatedRoute, Router } from "@angular/router";
import worldNationalities from "../../../auth/models/nationality";
import EuropeanNationality from "../../../auth/models/european-nationality";
import { CandidateService } from "../../../modules/recruitment/candidates/candidate.service";
import { CollaboratorsService } from "../../../modules/collaborators/collaborators.service";

@Component({
  selector: "app-landing-insert-data",
  templateUrl: "./landing-insert-data.component.html",
  styleUrls: ["./landing-insert-data.component.scss"],
})
export class LandingInsertDataComponent implements OnInit {
  public formGroup: FormGroup;

  public provinces_list: any = [];

  public document_id_types: Array<object> = [];

  public file_document_id: any;

  public file_permit: any;

  public file_fiscal_code: any;

  public currenDate: string = moment().format("YYYY-MM-DD");

  public eighteen_years_ago: string = moment().subtract(18, "year").format("YYYY-MM-DD");

  public currentUser: any;

  public sended: boolean = false;

  public isFiscalCodeGenerate: boolean = false;

  public fileNameFiscalCode: string = null;

  public fileNameDocument: string = null;

  public fileNameDocumentPermit: string = null;

  public nationalities_list: Array<string> = worldNationalities;

  public europeanNationalities: Array<string> = EuropeanNationality;

  public type_nationality: string = "";

  public idCityAltro: any = 0;

  public isACollaborator: boolean = false;

  public showErrors: boolean = false;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param _formBuilder
   * @param {CitiesService} _citiesService
   * @param {UtilsService} _utilService
   * @param _router
   * @param _activatedRoute
   * @param _changeDetectorRef
   * @param _candidateService
   * @param _collaboratorService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    public _formBuilder: FormBuilder,
    public _citiesService: CitiesService,
    public _utilService: UtilsService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    public _candidateService: CandidateService,
    private _collaboratorService: CollaboratorsService,
  ) {
    this._utilService.disableAutoHideLoading();
    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };

    this._coreConfigService.config.subscribe((params: any) => {
      this.document_id_types = params.custom.document_id_types;
    });

    this._activatedRoute.queryParams.subscribe((params) => {
      if (params.token && params.u) {
        localStorage.clear();
        localStorage.setItem("token", params.token);
        localStorage.setItem("candidate", params.u);
        localStorage.setItem("type", params.type);
        this._router.navigateByUrl(window.location.pathname);
      }
    });

    this.formGroup = this._formBuilder.group({
      firstname: new FormControl("", [Validators.required, Validators.minLength(2), Validators.maxLength(255)]),
      lastname: new FormControl("", [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
      sex: new FormControl("", [Validators.required]),
      birth_place: new FormControl(null, [Validators.required]),
      birthday: new FormControl(null, [Validators.required]),
      phone: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required, Validators.email]),
      fiscal_code: new FormControl("", [Validators.required, Validators.minLength(16), Validators.maxLength(16)]),
      document_type: new FormControl("", [Validators.required]),
      document_number: new FormControl("", [Validators.required]),
      document_valid_until: new FormControl("", [Validators.required]),
      residence_nationality: new FormControl(null, [Validators.required]),
      residence_street: new FormControl("", [Validators.required, Validators.minLength(1), Validators.maxLength(255)]),
      residence_zipcode: new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern("[0-9]+")]),
      residence_city: new FormControl(null, [Validators.required]),
      residence_province: new FormControl(null, [Validators.required]),
      document_residence_permit_number: new FormControl(""),
      document_residence_permit_valid_until: new FormControl(""),
      residence_permit_url: new FormControl(""),
    });
  }

  async ngOnInit() {
    await this._citiesService.getList();
    const city = this._citiesService.list.find((c) => c.name === "Altro");
    if (city) {
      this.idCityAltro = city.id;
    }
    this.provinces_list = this._citiesService.list
      .filter((c: any) => c.is_main)
      .sort((a: any, b: any) => {
        a = a.name;
        b = b.name;
        return a > b ? 1 : a < b ? -1 : 0;
      });

    const hash: string = localStorage.getItem("candidate");
    const type: string = localStorage.getItem("type");
    if (hash) {
      if (type === "candidate") {
        this.currentUser = await this._candidateService.getCandidate(hash);
      } else {
        //Se non è un candidato è sicuramente un collaboratore
        this.currentUser = await this._collaboratorService.getCollaborator(hash);
        this.isACollaborator = true;
      }
      if (!this.currentUser) {
        await this._router.navigateByUrl("/");
      }
      if (Number(this.currentUser.completed_masterdata) === 1) {
        this.sended = true;
      }

      this.formGroup.patchValue({
        sex: this.currentUser.sex || null,
        fiscal_code: this.currentUser.fiscal_code || null,
        firstname: this.currentUser.firstname || "",
        lastname: this.currentUser.lastname || "",
        birth_place: this.currentUser.birth_place_id || null,
        birthday: this.currentUser.birthday ? moment(this.currentUser.birthday).format("YYYY-MM-DD") : null,
        phone: this.currentUser.phone,
        email: this.currentUser.email || "",
        residence_nationality: this.currentUser?.nationality || "",
      });
      if (this.currentUser.document_id) {
        this.formGroup.patchValue({
          document_number: this.currentUser.document_id.number || null,
          document_type: this.currentUser.document_id.type || null,
          document_valid_until: this.currentUser.document_id.valid_until || null,
        });
      }
      if (this.currentUser.addresses && this.currentUser.addresses.residenza) {
        this.formGroup.patchValue({
          residence_street: this.currentUser.addresses.residenza.street || null,
          residence_city: this.currentUser.addresses.residenza.city_id || null,
          residence_province: this.currentUser.addresses.residenza.province_id || null,
          residence_zipcode: this.currentUser.addresses.residenza.zipcode || null,
        });
      }
      if (this.currentUser && this.currentUser.nationality && this.currentUser.nationality.length > 0 && this.currentUser.nationality === "Italiana") {
        this.type_nationality = "Italiana";
      } else if (this.currentUser && this.currentUser.nationality && this.currentUser.nationality.length > 0 && this.europeanNationalities.includes(this.currentUser.nationality)) {
        this.type_nationality = "UE";
      } else if (
        this.currentUser &&
        this.currentUser.nationality &&
        this.currentUser.nationality.length > 0 &&
        this.currentUser.nationality !== "Italiana" &&
        !this.europeanNationalities.includes(this.currentUser.nationality)
      ) {
        this.type_nationality = "Extra Ue";
      }
      this._changeDetectorRef.detectChanges();
    }

    this._utilService.hideLoading();
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  setAutoProvince(type: string) {
    const cityForm: number = this.formGroup.get(type + "_city").value;
    if (cityForm > 0) {
      const cityObj: any = this._citiesService.list.find((city: any) => city.id === cityForm);
      const province = this._citiesService.list.find((city: any) => city.initials === cityObj.initials && city.is_main === 1);
      this.formGroup.patchValue({ residence_province: province.id });
    }
  }

  handlerChangeFileInput(event: any, what: string) {
    const extensionPermitted = ["pdf", "jpg", "jpeg"];
    const file = event.target.files[0].name;
    const extension = file.split(".").pop().toLowerCase();

    if (extensionPermitted.includes(extension)) {
      if (what === "fiscal-code") {
        this.fileNameFiscalCode = event.target.files[0].name;
      } else if (what === "residence_permit") {
        this.fileNameDocumentPermit = event.target.files[0].name;
      } else if (what === "document-id") {
        this.fileNameDocument = event.target.files[0].name;
      }
      this._utilService.convertFileToBase64(event, (e: any) => {
        const r = e.target.result;
        switch (what) {
          case "document-id":
            this.file_document_id = r;
            break;
          case "fiscal-code":
            this.file_fiscal_code = r;
            break;
          case "residence_permit":
            this.file_permit = r;
            break;
        }
      });
    } else {
      this._utilService.showSWALError({ text: "INVALID_FORMAT" });
      event.target.value = null;
    }
  }

  setCountry() {
    const birthPlace = this.formGroup.get("birth_place") as FormGroup;
    //Cosi i clearValidators funzionano realmente
    const documentPermitNumber = this.formGroup.get("document_residence_permit_number") as FormGroup;
    documentPermitNumber.clearValidators();
    documentPermitNumber.updateValueAndValidity();

    const documentPermitValidUntil = this.formGroup.get("document_residence_permit_valid_until") as FormGroup;
    documentPermitValidUntil.clearValidators();
    documentPermitValidUntil.updateValueAndValidity();

    this.formGroup.controls.birth_place.setValidators([Validators.required]);
    this.formGroup.patchValue({
      residence_nationality: "",
    });
    if (this.type_nationality == "Italiana") {
      this.formGroup.patchValue({
        residence_nationality: "Italiana",
      });
      this.calculateFiscalCode();
    }
    if (this.type_nationality === "UE") {
      this.formGroup.patchValue({
        fiscal_code: "",
      });
      birthPlace.clearValidators();
      birthPlace.updateValueAndValidity();
    }
    if (this.type_nationality === "Extra Ue") {
      this.formGroup.controls.document_residence_permit_number.setValidators([Validators.required]);
      this.formGroup.controls.document_residence_permit_valid_until.setValidators([Validators.required]);
      this.formGroup.patchValue({
        fiscal_code: "",
      });
      birthPlace.clearValidators();
      birthPlace.updateValueAndValidity();
    }
  }

  calculateFiscalCode() {
    if (
      this.formGroup.value.residence_nationality === "Italiana" &&
      this.formGroup.value.firstname.length > 0 &&
      this.formGroup.value.lastname.length > 0 &&
      this.formGroup.value.sex.length > 0 &&
      this.formGroup.value.birthday &&
      this.formGroup.value.birth_place > 0 &&
      (this.formGroup.value.sex == "m" || this.formGroup.value.sex == "f")
    ) {
      this._utilService
        .calculateFiscalCode(this.formGroup.value.firstname, this.formGroup.value.lastname, this.formGroup.value.sex, this.formGroup.value.birthday, this.formGroup.value.birth_place)
        .then((response: any) => {
          this.formGroup.patchValue({ fiscal_code: response.cf });
          this.isFiscalCodeGenerate = true;
        });
    } else {
      this.formGroup.patchValue({ fiscal_code: "" });
      this.isFiscalCodeGenerate = false;
    }
  }

  async save() {
    this.showErrors = false;
    if (this.formGroup.invalid) {
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }

    if (!this.file_document_id) {
      await this._utilService.showSWALError({ text: "INSERT_ID_DOCUMENT" });
      this.showErrors = true;
      return false;
    }

    if (!this.file_fiscal_code) {
      await this._utilService.showSWALError({ text: "INSERT_FISCAL_CODE_FILE" });
      this.showErrors = true;
      return false;
    }

    if (this.type_nationality === "Extra Ue" && !this.file_permit) {
      await this._utilService.showSWALError({ text: "INSERT_PERMIT_DOCUMENT_FILE" });
      this.showErrors = true;
      return false;
    }

    let data: any = this.formGroup.value;
    let isNotAdult = moment(data.birthday).isAfter(this.eighteen_years_ago);
    if (isNotAdult) {
      //CONTROL BIRTHDAY
      return this._utilService.showSWALError({ text: "BIRTH_DATE_ERROR" });
    } //CONTROL EXPIRE DOCUMENT
    if (data.document_valid_until < this.currenDate) {
      return this._utilService.showSWALError({ text: "EXPIRE_DATE_ERROR" });
    }
    let dataToSend: any = null;
    if (!this.isACollaborator) {
      dataToSend = {
        firstname: data.firstname,
        lastname: data.lastname,
        sex: data.sex,
        birth_place: data.birth_place,
        birthday: data.birthday,
        phone: data.phone,
        email: data.email,
        nationality: data.residence_nationality,
        fiscal_code: data.fiscal_code,
        address: {
          street: data.residence_street,
          zipcode: data.residence_zipcode,
          city: data.residence_city,
          province: data.residence_province,
        },
        document_id: {
          type: data.document_type,
          number: data.document_number,
          valid_until: data.document_valid_until,
          document_url: "",
          fiscalcode_url: "",
          residence_permit_number: data.document_residence_permit_number,
          residence_permit_valid_until: data.document_residence_permit_valid_until,
          residence_permit_url: "",
        },
      };
    } else {
      dataToSend = {
        firstname: data.firstname,
        lastname: data.lastname,
        sex: data.sex,
        birth_place: data.birth_place,
        birthday: data.birthday,
        private_phone: data.phone,
        private_email: data.email,
        nationality: data.residence_nationality,
        fiscal_code: data.fiscal_code,
        address: {
          street: data.residence_street,
          zipcode: data.residence_zipcode,
          city: data.residence_city,
          province: data.residence_province,
        },
        document_id: {
          type: data.document_type,
          number: data.document_number,
          valid_until: data.document_valid_until,
          document_url: "",
          fiscalcode_url: "",
          residence_permit_number: data.document_residence_permit_number,
          residence_permit_valid_until: data.document_residence_permit_valid_until,
          residence_permit_url: "",
        },
      };
    }
    const userMinioDir: string = `users/${this.currentUser.hash}/`;
    const baseDocumentFileName: string = `${userMinioDir}documento-didentita/`;
    this._utilService.showLoading();
    //AREA DOCUMENTS
    if (this.file_document_id) {
      const fileDocumentIdExt: string = this.file_document_id.split(";base64,")[0].split("/")[1];
      await this._utilService
        .upload_media("documents", baseDocumentFileName + data.document_type + "." + fileDocumentIdExt, this.file_document_id)
        .then(() => {
          dataToSend.document_id.document_url = `users/${this.currentUser.hash}/documento-didentita/${data.document_type}.${fileDocumentIdExt}`;
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ID_DOCUMENT_UPLOAD_ERROR" });
        });
    }

    if (this.file_fiscal_code) {
      const fileDocumentIdExt: string = this.file_fiscal_code.split(";base64,")[0].split("/")[1];
      await this._utilService
        .upload_media("documents", baseDocumentFileName + "fiscal-code." + fileDocumentIdExt, this.file_fiscal_code)
        .then(() => {
          dataToSend.document_id.fiscalcode_url = `users/${this.currentUser.hash}/documento-didentita/fiscal-code.${fileDocumentIdExt}`;
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "FISCAL_CODE_UPLOAD_ERROR" });
        });
    }

    if (this.file_permit) {
      const fileExtension: string = this.file_permit.split(";base64,")[0].split("/")[1];
      await this._utilService
        .upload_media("documents", `${userMinioDir}permesso-di-soggiorno/file.${fileExtension}`, this.file_permit)
        .then(() => {
          dataToSend.document_id.residence_permit_url = `users/${this.currentUser.hash}/permesso-di-soggiorno/file.${fileExtension}`;
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "RESIDENCE_PERMIT_UPLOAD_ERROR" });
        });
    }

    if (Object.keys(dataToSend).length < 1) {
      this._utilService.hideLoading();
      return this._utilService.showSWAL({
        title: "ALERT_TITLE",
        text: "NOTHING_TO_UPDATE",
        icon: "warning",
        confirmButtonText: "BTN_CLOSE",
        showCancelButton: false,
        customClass: {
          confirmButton: "btn btn-warning",
        },
      });
    }
    if (this.type_nationality === "UE" || this.type_nationality === "Extra Ue") {
      dataToSend.birth_place = this.idCityAltro;
    }
    if (!this.isACollaborator) {
      //Se è un candidato
      return this._candidateService
        .updateCandidateLanding(dataToSend)
        .then(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_USER_DATA_INSERT" });
          this.sended = true;
          localStorage.clear();
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_USER_DATA_INSERT" });
        });
    } else {
      //Se è un collaboratore
      return this._collaboratorService
        .updateCollaboratorLanding(dataToSend)
        .then(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_USER_DATA_INSERT" });
          this.sended = true;
          localStorage.clear();
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_USER_DATA_INSERT" });
        });
    }
  }
}
